import Api from "./axios";

export const updateTerms = async (data) => {
  return await Api.put(`/v1/terms-and-conditions`, data);
};

export const getTerms = async (data) => {
  return await Api.get(`/v1/terms-and-conditions`);
};
